import { render } from "./addDocumentTemplateForm.vue?vue&type=template&id=ef110546&scoped=true"
import script from "./addDocumentTemplateForm.vue?vue&type=script&lang=js"
export * from "./addDocumentTemplateForm.vue?vue&type=script&lang=js"

import "./addDocumentTemplateForm.vue?vue&type=style&index=0&id=ef110546&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef110546"]])

export default __exports__